/**
 * The price to show before checkout. Stripe decides the real currency at
 * checkout from where the person is (one price, USD 12.99 with an INR 499
 * option); this mirrors it from the device's time zone so the page and the
 * checkout agree for nearly everyone.
 */
const INDIA_TIME_ZONES = new Set(["Asia/Kolkata", "Asia/Calcutta"]);

export function localPrice(timeZone: string | undefined): string {
  return timeZone && INDIA_TIME_ZONES.has(timeZone) ? "₹499" : "$12.99";
}

/** The amount and currency Stripe will charge, for the purchase report. */
export function localAmount(timeZone: string | undefined): { readonly currency: "INR" | "USD"; readonly value: number } {
  return timeZone && INDIA_TIME_ZONES.has(timeZone) ? { currency: "INR", value: 499 } : { currency: "USD", value: 12.99 };
}

export { deviceTimeZone } from "@/lib/time-zone";
